import { useAlert } from '@/libs/alertPortal'
import type { UpdateContractInput } from '@/types/schema.generated'
import {
  useGenerateStripeCreditCardSavingUrlMutation,
  useUpdateContractMutation,
} from './useContract.generated'

export const useUpdateContract = () => {
  const { mutate } = useUpdateContractMutation({})

  const alert = useAlert()

  const updateContract = async (contract: UpdateContractInput) => {
    try {
      await mutate({
        input: contract,
      })
      alert.success('請求先情報を更新しました。')
    } catch {
      alert.error(
        'エラーが発生しました。再度お試しいただくか、サポートにお問い合わせください。'
      )
    }
  }

  return { updateContract }
}

export const useGenerateStripeCreditCardSavingUrl = (
  successCallbackUrl: string,
  cancelCallbackUrl: string
) => {
  const { mutate } = useGenerateStripeCreditCardSavingUrlMutation({})

  const generateStripeCreditCardSavingUrl = async () => {
    const result = await mutate({
      successCallbackUrl,
      cancelCallbackUrl,
    })
    if (result?.data) {
      return result.data.generateStripeCreditCardSavingUrl
    }
    throw new Error('failed to generate stripe credit card saving url')
  }

  return { generateStripeCreditCardSavingUrl }
}
